// extracted by css-extract-rspack-plugin
export default {"attention":"WIc8OB"};